import useSWR from 'swr'

import { tryParse } from './createRestClient'

declare global {
  interface Window {
    _env_: { [name: string]: string }
  }
}

let env: { [name: string]: string } = {}

async function fetchEnv() {
  const response = await fetch('env.json')
  const json = await tryParse(response)
  env = Object.freeze(json)

  // Return a non-undefined, otherwise `useSWR` could not distinguish between a loading state and a resolved promise
  return null
}

export function EnvFetcher(props: { children: React.ReactElement }): React.ReactElement | null {
  const { data, error } = useSWR('env', fetchEnv)

  if (error) {
    throw error
  }

  if (data === undefined) {
    // Do not render a loading indicator here as fetching env vars is supposed to be fast enough
    return null
  }

  return props.children
}

export function getBillingApiUrl() {
  return env.BILLING_API_URL
}

export function getPathPrefix() {
  return env.PATH_PREFIX
}

export function getTaskworldFrontendUrl() {
  return env.TASKWORLD_FRONTEND_URL
}

export function getStripePublicKey(stripeInstanceName: string | null): string {
  switch (stripeInstanceName) {
    case 'US':
      return env.STRIPE_US_PUBLIC_KEY
    default:
      return env.STRIPE_PUBLIC_KEY
  }
}

export function getGoogleAnalyticsKey() {
  return env.GOOGLE_ANALYTICS_KEY
}

export function getGoogleAdWordKey() {
  return env.GOOGLE_AD_WORDS_ID
}

export function getEnvironmentName() {
  return env.DD_ENV
}

export function getGoogleTagManagerId() {
  return env.GOOGLE_TAG_MANAGER_ID
}

export function isProduction(): boolean {
  if (
    import.meta.env.NODE_ENV === 'production' &&
    /https:\/\/(\w+-)?billing\.taskworld\.com/.test(window.location.origin)
  ) {
    return true
  }

  return false
}
